export const ebBackendEndpointsConfig = {
  addresses: 'orgUsers/${userId}/addresses?fields=FULL',
  availability: '/orgUsers/${userId}/availability',
  baseSites: 'basesites?fields=DEFAULT',
  cart: '/users/${userId}/carts/${cartId}?fields=FULL',
  cartAddEntries: 'orgUsers/${userId}/carts/${cartId}/entries/',
  quickAddCartEntries: 'orgUsers/${userId}/carts/${cartId}/entries/?isQuickAdd=true',
  contactUs: '/contact/form',
  contactUsFormTopics: '/contact/topics',
  contactUsCountries: '/contact/countries',
  typesOfEndCustomer: 'orgUsers/${userId}/contact/partners',
  setDestinationCountry: 'orgUsers/${userId}/carts/${cartId}/targetCountry',
  setOrderNote: 'orgUsers/${userId}/carts/${cartId}/note',
  setTypeOfEndCustomer: 'orgUsers/${userId}/carts/${cartId}/businessPartner',
  customerInfo: 'orgUsers/${userId}/customers/getCustomerInfo',
  customerMeasuringUnit: '/customerMeasuringUnit',
  decryptVariantCode: 'products/decrypt/${encrypted}',
  downloadDocument: '/medias/${mediaCode}',
  earliestShippingDate: '/orgUsers/${userId}/earliestShippingDate',
  orderDetail: 'orgUsers/${userId}/orders/${orderId}?fields=FULL',
  orders: 'orgUsers/${userId}/orders/search',
  ebPlaceOrder: 'orgUsers/${userId}/carts/${cartId}/orders?fields=FULL',
  prices: 'orgUsers/${userId}/prices?fields=FULL',
  product: {
    details: 'products/${productCode}?fields=DEFAULT,classifications'
  },
  downloadCsvTemplate: 'orgUsers/${userId}/carts/${cartId}/csvTemplate',
  downloadOrderDocument: 'orgUsers/${userId}/orders/download',
  uploadCsvFile: 'orgUsers/${userId}/carts/${cartId}/uploadCsv',
  structuredProductData: 'products/schema/${productCode}',
  productSearch:
    'products/search?fields=' +
    'products(code,name,summary,configurable,configuratorType,price(FULL),' +
    'images(DEFAULT),stock(FULL),averageRating,variantOptions,fullProductPath),' +
    'facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery,keywordRedirectUrl,categoryName,categoryDescription,categoryImage,fuzzyProducts(FULL)',
  requestedShippingDate:
    '/orgUsers/${userId}/carts/${cartId}/requestedShippingDate?isValidationNeeded=${isValidationNeeded}&changedByCustomer=${changedByCustomer}',
  requestProduct: 'quotes/requestProduct',
  requestQuote: 'quotes/${productCode}/requestQuote',
  setCartPaymentType: '/orgUsers/${userId}/carts/${cartId}/paymentType',
  setCompleteDelivery:
    '/orgUsers/${userId}/carts/current/completeDelivery?completeDelivery=${completedDelivery}',
  setShippingAddressChange: '/orgUsers/${userId}/addresses/${addressId}/create',
  addEbCommerceAddress: '/orgUsers/${userId}/addresses/create',
  editEbCommerceAddress: '/orgUsers/${userId}/addresses/${addressId}/update',
  deleteEbCommerceAddress: '/orgUsers/${userId}/addresses/${addressId}/delete',
  shippingCountries: 'orgUsers/${userId}/countries?type=shipping',
  variants:
    'variants/search?query=${freeTextSearch}:${sorting}:parentCode:${productCode}${query}&fields=facets,features,breadcrumbs,products(DEFAULT)',
  salesArea: 'users/current/forbiddenSalesArea',
  loadAsmClientSession: '/asm/login',
  setAgentSession: '/asm',
  logoutAsmAgent: '/asm/logout',
  asmCustomerLogout: '/asm/customerLogout',
  asmCustomerSearch: '/assistedservicewebservices/customers/search',
  asmCustomerLists: '/assistedservicewebservices/customerlists',
  asmBindCart: '/assistedservicewebservices/bind-cart',
  asmCreateCustomer: '/assistedservicewebservices/customers',
  asmSessionEvent: 'assistedservicewebservices/${baseSiteId}/users/${userId}/asmSessionEvents',
  pages: 'cms/pages',
  page: 'cms/pages/${id}'
}
